'use strict';

var defineProperty = require('../../node_modules/@babel/runtime/helpers/defineProperty.js');
var objectWithoutProperties = require('../../node_modules/@babel/runtime/helpers/objectWithoutProperties.js');
var React = require('react');
var withStyles = require('../../node_modules/@material-ui/core/esm/styles/withStyles.js');
var Card = require('../../node_modules/@material-ui/core/esm/Card/Card.js');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }
var boxShadow = '0px 0px 12px 2px rgba(0, 0, 0, .1), 0px 0px 0px 0px rgba(0, 0, 0, .1), 0px 0px 0px 0px rgba(0, 0, 0, .1)';

var styles = function styles(theme) {
  var _theme$customShadows;

  return {
    root: {
      overflow: 'inherit',
      borderRadius: 8,
      boxShadow: (theme === null || theme === void 0 ? void 0 : (_theme$customShadows = theme.customShadows) === null || _theme$customShadows === void 0 ? void 0 : _theme$customShadows.card) || boxShadow
    }
  };
};

var HCCard = function HCCard(_ref) {
  var classes = _ref.classes,
      children = _ref.children,
      props = objectWithoutProperties(_ref, ["classes", "children"]);

  return React__default["default"].createElement(Card["default"], _objectSpread({
    className: classes.root
  }, props), children);
};

var HCCard$1 = withStyles(styles)(HCCard);

module.exports = HCCard$1;
